import { Widget } from '../widget/widget.js';

export class NumberWidget extends Widget {
    async validate() {
        this.clearError();
        let valid = true;

        if (this.$input.value.length === 0) {
            this.$input.value = '0';
        }

        const value = parseInt(this.$input.value);

        if (Number.isNaN(Number(value))) {
            this.displayError('Der eingegebene Wert muss eine Zahl sein.');
            valid = false;
        }

        if (this.required && this.$input.value.length === 0) {
            this.displayError('widget.is_required');
            valid = false;
        }

        return valid;
    }

    async getValue() {
        return this.$input.value.length === 0 ? null : parseInt(this.$input.value);
    }
}
